export function setClientId(clientId) {
  return {
    type: '@azure/SET_CLIENT_ID',
    payload: { clientId },
  }
}

export function setTenantId(tenantId) {
  return {
    type: '@azure/SET_TENANT_ID',
    payload: { tenantId },
  }
}
